<template>
  <div ref="Neysla" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.neysla.pageLabel") }}</h1>
    <hr class="primary" />
    <a href="https://www.npmjs.com/package/neysla" rel="noreferrer,noopener" target="_blank">
      <img
        :alt="$t('portfolio.neysla.npmAltLabel')"
        src="https://nodei.co/npm/neysla.png?mini=true"
        class="margin-h-sm"
      />
    </a>
    <img
      :alt="$t('portfolio.neysla.packageAltLabel')"
      src="https://img.shields.io/badge/package-v3.8.3-orange.svg"
      class="margin-h-sm"
    />
    <img
      :alt="$t('portfolio.neysla.dependenciesAltLabel')"
      src="https://img.shields.io/badge/dependencies-none-green.svg"
      class="margin-h-sm"
    />
    <a href="https://travis-ci.org/onca-vega/Neysla" rel="noreferrer,noopener" target="_blank">
      <img
        :alt="$t('portfolio.neysla.buildAltLabel')"
        src="https://img.shields.io/badge/build-passing-brightgreen.svg"
        class="margin-h-sm"
      />
    </a>
    <a
      href="https://coveralls.io/github/onca-vega/Neysla?branch=master"
      rel="noreferrer,noopener"
      target="_blank"
    >
      <img
        :alt="$t('portfolio.neysla.coverageAltLabel')"
        src="https://coveralls.io/repos/github/onca-vega/Neysla/badge.svg?branch=master"
        class="margin-h-sm"
      />
    </a>
    <router-view :responseTitle="responseTitle" :responseData="responseData"></router-view>
  </div>
</template>

<script>
export default {
  name: "Neysla",
  computed: {
    /*
     * @computed - responseTitle
     * Adds header values to response data table
     */
    responseTitle() {
      return [
        {
          name: "attribute",
          displayName: this.$t("portfolio.neysla.response.table.title.columnAttribute")
        },
        {
          name: "description",
          displayName: this.$t("portfolio.neysla.response.table.title.columnDescription")
        },
        {
          name: "datatype",
          displayName: this.$t("portfolio.neysla.response.table.title.columnDatatype")
        }
      ];
    },
    /*
     * @computed - responseData
     * Adds data values to response data table
     */
    responseData() {
      return [
        {
          attribute: "headers",
          description: this.$t("portfolio.neysla.response.table.data.rowHeaders"),
          datatype: "object"
        },
        {
          attribute: "status",
          description: this.$t("portfolio.neysla.response.table.data.rowStatus"),
          datatype: "number"
        },
        {
          attribute: "statusText",
          description: this.$t("portfolio.neysla.response.table.data.rowStatusText"),
          datatype: "string"
        },
        {
          attribute: "data",
          description: this.$t("portfolio.neysla.response.table.data.rowData"),
          datatype: "object"
        },
        {
          attribute: "dataType",
          description: this.$t("portfolio.neysla.response.table.data.rowDataType"),
          datatype: "string"
        },
        {
          attribute: "url",
          description: this.$t("portfolio.neysla.response.table.data.rowUrl"),
          datatype: "string"
        },
        {
          attribute: "getHeader( :headerName* )",
          description: this.$t("portfolio.neysla.response.table.data.rowGetHeader"),
          datatype: "function"
        }
      ];
    }
  }
};
</script>
